import React, { Component } from 'react';
import { bindActionCreators} from 'redux';
import {Label, Icon} from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import CategoryTagSelector from '../../includes/selectors/CategoryTagSelector';
import {
    addCategoryToResource,
    deleteCategoryToResource
} from '../../../actions/category';
import {
    ADD_CATEGORY_TO_INVENTORY,
    DELETE_CATEGORY_TO_INVENTORY
} from '../../../actions/types';
import Lara from '../../../lara';
import AlertComponent from '../../includes/messages/alert';

class InventoryCategoryPane extends Component {
    onCategorySelectorSelected = (item) => {
        if (!item) {
            return;
        }
        const {categories} = this.props;
        const existCategory = categories.filter(c => {
            return c.name === item;
        });
        if (existCategory.length > 0) {
            return null;
        }
        this.props.addCategoryToResource(item, 'Inventory', this.props.id, ADD_CATEGORY_TO_INVENTORY).then(res => {
            
        }).catch(err => {
            const errors = Lara.axiosError(err, this.props.t);
            Lara.axiosAlert(<AlertComponent 
                support={errors.support}
                message={errors.message}
                reference={errors.reference}
                t={this.props.t}
            />);
        });
    }

    onRemoveCategoryClick = (category, index) => {
        this.props.deleteCategoryToResource(category.id, 'Inventory', this.props.id, index, 
            DELETE_CATEGORY_TO_INVENTORY).then(res => {
        }).catch(err => {
            const errors = Lara.axiosError(err, this.props.t);
            Lara.axiosAlert(<AlertComponent 
                support={errors.support}
                message={errors.message}
                reference={errors.reference}
                t={this.props.t}
            />);
        })
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        <CategoryTagSelector 
                            type='Inventory'
                            t={this.props.t}
                            resourceId={this.props.id}
                            onSelected={(value) => {
                                this.onCategorySelectorSelected(value)
                            }}
                        />
                    </div>
                </div>
                <div className="row lara-row-margin">
                    <div className="col-md-12 col-sm-12 col-xs-12">
                        {this.props.categories.map((i,index) => {
                            return (
                                <Label key={i.id} color='teal'>
                                    {i.name}
                                    <Icon name='delete'
                                        onClick={() => {this.onRemoveCategoryClick(i, index)}}
                                    />
                                </Label>
                            )
                        })}
                    </div>
                </div>
            </div>
        )
    }
}

InventoryCategoryPane.propTypes = {
    categories: PropTypes.array.isRequired,
    t: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    addCategoryToResource: PropTypes.func.isRequired,
    deleteCategoryToResource: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        addCategoryToResource,
    deleteCategoryToResource
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(InventoryCategoryPane);